import React from 'react'
import Select from '@hixme-ui/select'

export default () => <Select list={[{ id: '', name: 'Loading...' }]} disabled />
